import { c as _c } from "react/compiler-runtime";
import { AnalyticsFeedbackDialog } from "@components/analytics/in-house/feedback/analytics-feedback-dialog";
import { IconButton, Tooltip } from "@flat-ui";
import { useState } from "react";
import { FeedbackIcon } from "@flat-ui";

/**
 * Action button that opens the in-house premium analytics feedback survey on
 * demand. Rendered in the analytics tab bar's action area.
 */
export function AnalyticsProvideFeedbackButton() {
  const $ = _c(6);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsDialogOpen(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Tooltip title="Provide feedback"><IconButton onClick={t0} size="s"><FeedbackIcon /></IconButton></Tooltip>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isDialogOpen) {
    t2 = isDialogOpen && <AnalyticsFeedbackDialog onClose={() => setIsDialogOpen(false)} />;
    $[2] = isDialogOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}